import YogaMultipack from './YogaMultipack'

export default YogaMultipack
// eslint-disable-next-line import/export
export * from './YogaMultipack'
